import { ArrowUp, ArrowDown } from "lucide-react";

interface SortIconProps {
  field: "name" | "username" | "email";
  currentField: "name" | "username" | "email";
  sortOrder: "asc" | "desc";
}

export const SortIcon = ({ field, currentField, sortOrder }: SortIconProps) => {
  if (currentField !== field) return null;
  return sortOrder === "asc" ? (
    <ArrowUp className="ml-1 h-3 w-3 inline" />
  ) : (
    <ArrowDown className="ml-1 h-3 w-3 inline" />
  );
};
